<div class="cv-studio-pane-header">
  <h2>{{ layout.name }}</h2>
  <span class="cv-studio-pill cv-studio-pill-builtin">{{ 'cv_studio.pill_builtin' | translate }}</span>
</div>
<p class="cv-studio-pane-description">{{ layout.description }}</p>

<div class="cv-studio-pane-thumb">
  <img [src]="sampleImageUrl()" [alt]="layout.name + ' sample preview'" />
</div>

<div class="cv-studio-pane-actions">
  <button nbButton status="primary" (click)="emitUseAsBase()">
    {{ 'cv_studio.use_as_base_button' | translate }}
  </button>
  <a href="javascript:void(0)" class="cv-studio-text-link" (click)="downloadBlank()">
    {{ 'cv_studio.download_blank_button' | translate }}
  </a>
</div>
